import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Rocket } from 'lucide-react';

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const planesSection = document.getElementById('planes');
      const faqSection = document.getElementById('faq');
      
      if (planesSection && faqSection) {
        const planesRect = planesSection.getBoundingClientRect();
        const faqRect = faqSection.getBoundingClientRect();
        
        // Show button ONLY when:
        // 1. Plans section is at least 30% visible from the top
        // 2. FAQ section hasn't started yet (top is below viewport)
        const isPlanesVisible = planesRect.top < window.innerHeight * 0.7 && planesRect.bottom > window.innerHeight * 0.3;
        const isFaqNotStarted = faqRect.top > 0;
        
        setIsVisible(isPlanesVisible && isFaqNotStarted);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const planesSection = document.getElementById('planes');
    if (planesSection) {
      planesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          onClick={handleClick}
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.3 }}
          whileHover={{ 
            scale: 1.05,
            boxShadow: "0 0 20px rgba(251, 176, 64, 0.6)",
          }}
          whileTap={{ scale: 0.95 }}
          className="fixed right-4 top-1/2 transform -translate-y-1/2 z-40 bg-gradient-to-br from-[#fbb040] via-yellow-400 to-[#fbb040] text-black font-black py-3 px-4 rounded-full shadow-xl border-2 border-yellow-300 hover:border-white transition-all duration-300"
          style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
        >
          <div className="flex flex-col items-center gap-2">
            <Rocket size={20} className="rotate-90" />
            <span className="text-xs tracking-wide">ACTIVA TU META</span>
          </div>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;